import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import BreadCrumb from "Components/Common/BreadCrumb";
import BaseTable from "Components/Common/BaseTable";

import { convertUTCDateToLocalDate } from "utils/convertUTCDateToLocalDate";

const RECORDS_PER_PAGE = 20;

const serverSidePaginationConfig = { endpoint: "/eventlog/error" };

const columns = [
  {
    title: "Log Level",
    field: "logLevel",
  },
  {
    title: "User Id",
    field: "userId",
  },
  {
    title: "Message",
    field: "message",
  },
  {
    title: "Event Type",
    field: "eventType",
  },
  {
    title: "Time",
    renderCell: ({ timestamp }) =>
      convertUTCDateToLocalDate(timestamp).format("DD-MM-YYYY HH:mm:ss A"),
  },
  {
    title: "IP Address",
    field: "ipAddress",
  },
  {
    title: "Status Code",
    field: "statusCode",
  },
  {
    title: "User Agent",
    field: "userAgent",
  },
];

const ErrorActivities = ({ t }) => {
  return (
    <div className="page-content h-100">
      <BreadCrumb title={t("Event Logs")} />

      <BaseTable
        columns={columns}
        pageSize={RECORDS_PER_PAGE}
        paginationType="serverSide"
        serverSidePaginationConfig={serverSidePaginationConfig}
        maxHeight="calc(100vh - 185px)"
      />
    </div>
  );
};

export default withTranslation()(ErrorActivities);

ErrorActivities.propTypes = {
  t: PropTypes.func,
};
